import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"

import Heading, { Type } from "../../UI/Heading"
import Modal from "../../UI/Modal"

import { videoPath } from "../../../constants"

import {
  Section,
  Container,
  Content,
  Image,
  Description,
  Column,
  VideoElement,
  PlayIcon,
  ModalButton,
  ModalContent,
  VideoPlayer
} from "./styles"

import play from "../../../assets/play.svg"
import close from "../../../assets/close-white.svg"

const VideoText = ({
  title,
  description,
  image,
  backgroundColor,
  textColor,
  video,
}) => {

  // State
  const [modalOpen, setModalOpen] = useState(false)

  // Actions
  const onModalOpen = () => setModalOpen(true)
  const onModalClose = () => setModalOpen(false)

  // Modal open
  useEffect(() => {
    const handleKeyDown = event => {
      if (event.code === "Escape") {
        onModalClose()
      }
    }

    // Freeze content when modal is open
    document.body.style.overflow = modalOpen ? "hidden" : ""

    if (modalOpen) {
      window.addEventListener("keydown", handleKeyDown)

      // cleanup this component
      return () => window.removeEventListener("keydown", handleKeyDown)
    }
  }, [modalOpen])

  return (
    <Section color={backgroundColor}>
      <Container>
        <Column>
          <VideoElement onClick={onModalOpen} whileHover={{ scale: 1.1 }}>
            <PlayIcon src={play} alt="play" />
            <Image fluid={image.childImageSharp.fluid} alt={image.name} />
          </VideoElement>
        </Column>
        <Column>
          <Content color={textColor}>
            <Heading type={Type.h2}>{title}</Heading>
            <Description>{description}</Description>
          </Content>
        </Column>
      </Container>
      <Modal isOpen={modalOpen}>
        <ModalButton role="button" tabIndex={0} onClick={onModalClose}>
          <img src={close} alt="close" />
        </ModalButton>
        <ModalContent>
          <VideoPlayer
            width={1200}
            className="video-player"
            video={`${videoPath}/${video}`}
            paused={!modalOpen}
          />
        </ModalContent>
      </Modal>
    </Section>
  )
}

VideoText.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.object,
  video: PropTypes.string,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
}

export default VideoText
